import { InvitationDetails, GuestUpdate, Settings } from "../models/api/rsvpApiTypes"
import axiosFrontend from "./clientApi"

export function getGuestsByReservationCodeAPI(tenant: string, reservationCode: string) {
  return new Promise<InvitationDetails>((resolve, reject) => {
    axiosFrontend
      .get(`/rsvp/${tenant}/invitation/${reservationCode}`)
      .then((response) => {
        resolve(response.data)
      })
      .catch((err) => {
        reject(err)
      })
  })
}

export function getStyleSettingsAPI(tenant: string) {
  return new Promise<Settings>((resolve, reject) => {
    axiosFrontend
      .get(`/rsvp/${tenant}`)
      .then((response) => {
        const settings: Settings = response.data

        let baseUrl = (axiosFrontend.defaults.baseURL || process.env.REACT_APP_BASE_URL || "").replace(/\/+$/g, "")
        // backend may expose the API under a subpath (e.g. http://host:5137/api)
        // while static assets live at the root.  strip the trailing `/api` segment
        // before prefixing icon paths so they resolve correctly.
        if (baseUrl.toLowerCase().endsWith("/api")) {
          baseUrl = baseUrl.slice(0, -4)
        }
        if (baseUrl && settings.steps) {
          settings.steps = settings.steps.map((step) => {
            if (step.icon && step.icon.trim().length > 0) {
              const trimmed = step.icon.trim()
              // Already absolute?  leave as-is.
              if (!/^https?:\/\//i.test(trimmed) && !trimmed.startsWith(baseUrl)) {
                // ensure we don't accidentally double-slash the path
                const relative = trimmed.replace(/^\/+/, "")
                step.icon = `${baseUrl}/${relative}`
              }
            }
            return step
          })
        }

        resolve(settings)
      })
      .catch((err) => reject(err))
  })
}
export function updateGuestsConfirmAPI(tenant: string | undefined, payload: GuestUpdate) {
  return new Promise<string[]>((resolve, reject) => {
    axiosFrontend
      .put(`/rsvp/${tenant}`, payload)
      .then((response) => {
        resolve(response.data)
      })
      .catch((err) => reject(err))
  })
}
